import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";

export default class PageHeader extends DetailViewContentElement {
  display_actions: boolean= true;

  font_size: number;
  constructor() {
    super();
    this.defineProperty("display_actions", true);

  }
}